import { shop } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';

export default function ShopServiceInfo({
  shop,
  count = 0,
}: {
  shop?: shop;
  count?: string | number;
}) {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <span className={styles.count}>{count}</span> خدمت قابل رزرو · نزدیک‌ترین نوبت{' '}
        <span className={styles.slot}>{shop?.closestTime}</span>
      </div>

      <a href="/services" className={styles.link}>
        مقایسه با مراکز دیگر ›
      </a>
    </div>
  );
}
